module.exports = __webpack_public_path__ + "static/media/vcep-logo.f79d2175.svg";